/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { BrokenRule } from "./broken-rule";

/**
 *
 * @export
 * @interface DocumentLine
 */
export interface DocumentLine {
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  AccountCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  AccountFormatCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  AmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  BaseEntry?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  BaseLine?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  BaseType?: DocumentLineBaseTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedAmountPrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedAmountPretax?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedAmountValue?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedInvoiceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedInvoiceRate?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedNetWeight?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedPrice?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CalculatedPriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  CreateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  CreateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  CustomsValue?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DeliveryQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  DeliveryUnitOfMeasureCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  Description?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountAmount1?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountAmount2?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountAmount3?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountPercent1?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountPercent2?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DiscountPercent3?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  DocEntry?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  FreightAllowanceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  FreightChargeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  FuelSurchargePercent?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  GrossWeight?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  InventoryTransaction?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  InvoiceAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  InvoiceFuelSurchargeAmount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  InvoiceQuantity?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  InvoiceRate?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  InvoiceUnitOfMeasureCode?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DocumentLine
   */
  IsDraft?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DocumentLine
   */
  IsTaxOnly?: boolean;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ItemCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  ItemCost?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ItemName?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ItemShortName?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  LineNumber?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  MaxWeight?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ModeOfTransportationCode?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  NetWeight?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ObjectType?: DocumentLineObjectTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof DocumentLine
   */
  PickStatus?: boolean;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  PostedPrice?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  PrepaidDiscountPercent?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  Price?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  PriceBeforePrepaidDiscount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  Quantity?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  Region?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  ReleaseNumber?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  SalesTermsCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ScaleUnitOfMeasureCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ShipDate?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ShipFrom?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ShipTo?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  ShipToType?: DocumentLineShipToTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  TareWeight?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  TargetEntry?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  TargetType?: DocumentLineTargetTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  TaxAmount?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  TaxCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  UnitOfMeasureCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  UpdateDateTime?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  UpdateUser?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentLine
   */
  VisualOrder?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  WarehouseCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentLine
   */
  WarehouseName?: string | null;
  /**
   *
   * @type {Array<BrokenRule>}
   * @memberof DocumentLine
   */
  BrokenRules?: Array<BrokenRule> | null;
}

/**
 * @export
 * @enum {string}
 */
export enum DocumentLineBaseTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
/**
 * @export
 * @enum {string}
 */
export enum DocumentLineObjectTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
/**
 * @export
 * @enum {string}
 */
export enum DocumentLineShipToTypeEnum {
  None = "None",
  Address = "Address",
  Region = "Region",
}
/**
 * @export
 * @enum {string}
 */
export enum DocumentLineTargetTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
